function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    padding: 0.5rem 1rem;\n    border-radius: 3px;\n    background-color: ",
        ";\n    background-size: cover;\n    border: 1px solid transparent;\n    font-family: Montserrat;\n    font-size: 14px;\n    color: #ffffff;\n    text-decoration: none solid rgb(255, 255, 255);\n    text-align: center;\n    cursor: pointer;\n    transition: 0.1s linear;\n    outline: none;\n    &:hover {\n        opacity: 0.75;\n        transform: translate3d(0, -2px, 0);\n    }\n    &:disabled {\n        background-color: rgba(138, 138, 138, 0.2);\n        color: #8a8a8a;\n        box-shadow: none;\n        cursor: not-allowed;\n        &:hover {\n            opacity: 1;\n            transform: none;\n            background-color: rgba(138, 138, 138, 0.2);\n            color: #8a8a8a;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    padding: 0.5rem 1rem;\n    border-radius: 3px;\n    background-color: #f7f7f7;\n    background-size: cover;\n    font-family: Montserrat;\n    font-size: 14px;\n    color: #202834;\n    text-decoration: none solid rgb(32, 40, 52);\n    text-align: center;\n    border: 1px solid transparent;\n    transition: 0.1s linear;\n    cursor: pointer;\n    font-size: 16px;\n    outline: none;\n    &:hover {\n        background: #ebebeb;\n    }\n    &:disabled {\n        background-color: rgba(138, 138, 138, 0.2);\n        color: #8a8a8a;\n        box-shadow: none;\n        cursor: not-allowed;\n        &:hover {\n            opacity: 1;\n            transform: none;\n            background-color: rgba(138, 138, 138, 0.2);\n            color: #8a8a8a;\n        }\n    }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { BrandingHexColors } from '../GlobalStyle';
export var Button = styled.button(_templateObject(), function(p) {
    return p.$primary ? BrandingHexColors.PARADIGM_GREEN : BrandingHexColors.BUILDERS_BLUE;
});
export var SecondaryButton = styled.button(_templateObject1());
